/**
 *   Puts layoutContainer child items inside a wrapper to improve styling options
 *
 * @example
 * contentWrapper()
 *
 */

function layoutContainerContentWrapper() {
  // const layoutOutContainers = document.querySelectorAll('.user_mode div.layoutContainer.content-width')
  const layoutOutContainers = document.querySelectorAll('.user_mode div.layoutContainer:not(.layout-20-20-20-20-20)')

  // need to process the home page top layoutcontainer to account for split column bg color
  const homeTopContentCt = document.querySelector('.home #panelTwo .layoutContainer.row.layout-66-33')

  if (homeTopContentCt) {

    const columnElement = homeTopContentCt.querySelector('.column')

    if (columnElement) {
      const columnBgColor = window.getComputedStyle(columnElement).backgroundColor

      if (columnBgColor && columnBgColor === 'rgb(255, 255, 255)') {
        homeTopContentCt.classList.add('layout-2')
      }
    }
  }

  layoutOutContainers.forEach((container) => {
    //console.log('wrap')
    const wrapper = document.createElement('div')
    wrapper.classList.add('layoutContainer-ct-wrap')

    // Move all child nodes into the wrapper
    while (container.firstChild) {
      wrapper.appendChild(container.firstChild)
    }

    // Append the wrapper back to the container
    container.appendChild(wrapper)
  })
}
